// extracted by mini-css-extract-plugin
export default {"notice":"_972e04ca","label":"_92bbb16","shippingFormWrapper":"_9bab20e7","mobileFormWrapper":"_7d3d7bd5"};